export default {
  "path": "",
  "configs": {},
  "blocks": [{
    "_vid": "_vidodkjlknnssggpfss4elo",
    "moduleName": "baseCtls",
    "componentKey": "xmDiv",
    "label": "块级元素Div",
    "styles": {},
    "props": {
      "width": "100%",
      "height": "100%",
      "label": "布局Div",
      "key": "keyflnndngissniknss4pmj",
      "bigScreen": true
    },
    children:[{
      props:{},
      "componentKey": "xmEmptyPage",
    }]
  }],
  "state": {
  },
  "stateRemarks": [
  ],
  "evetns": [],
  "active": true
}
